<template>
  <material-card  v-if="$store.state.menu.Products" class="card-tabs" color="#004D40">
    <v-flex slot="header">
      <v-tabs v-model="tabs" color="transparent" slider-color="white">
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-package-variant-closed</v-icon>Продукция
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-format-list-checkbox</v-icon>Категории
        </v-tab>
        <v-tab>
          <v-icon class="mr-2">mdi-slack</v-icon>Бренды
        </v-tab>
        <v-tab>
          <v-icon class="mr-2">mdi-format-list-bulleted-type</v-icon>Классы
        </v-tab>

        <v-tab>
          <v-icon class="mr-2">mdi-filter-outline</v-icon>Характеристики
        </v-tab>

        <v-tab>
          <v-icon class="mr-2">mdi-filter-variant</v-icon>Характеристики (значения)
        </v-tab>
      </v-tabs>
    </v-flex>

    <v-tabs-items>
      <v-tab-item>
        <div class="tab-products">
          <ProductCatalog v-if="tabs===0" />

          <CategoriesList v-else-if="tabs===1" />

          <BrandsList v-else-if="tabs===2" />

          <ClassList v-else-if="tabs===3" />

          <FeaturesList v-else-if="tabs===4" />

          <ValuesList v-else-if="tabs===5" />
        </div>
      </v-tab-item>
    </v-tabs-items>
  </material-card>
</template>
<script>
import ProductCatalog from "../components/core/Products/ProductCatalog";

import CategoriesList from "../components/core/Products/CategoriesList";

import BrandsList from "../components/core/Products/BrandsList";

import ClassList from "../components/core/Products/ClassList";
import FeaturesList from "../components/core/Products/FeaturesList";
import ValuesList from "../components/core/Products/ValuesList";

export default {
  components: {
    ValuesList,
    FeaturesList,
    ClassList,
    BrandsList,
    CategoriesList,
    ProductCatalog
  },
  data() {
    return {
      tabs: -1
    };
  },
  methods: {},
  mounted() {
    this.tabs = 0;
  }
};
</script>

<style>
.tab-products {
  min-height: 70vh;
}
</style>